/*
 * Copyright (C) 2018 Paymentus Inc.
 *
 * All rights reserved.
 *
 * The source code in this file is confidential and is the sole property of
 * Paymentus Inc. Its use is restricted to those readers who are authorized by
 * the corporation. Any reverse engineering or reproduction or divulgence of the
 * content of this report without the written consent from Paymentus Inc. is
 * strictly prohibited.
 *
 * Created on 8/20/18 2:17 PM
 * Created by kxian
 *
 */
import React from "react";
import {Consumer, FormValidator} from '../lib/form-validator';

const AppStateHolder = (props) => {
    const {initialState, config, app: App, devWidget: DevWidget, ...rest} = props;
    return (
        <FormValidator initialState={initialState} config={config}>
            <Consumer>
                {(state) => (
                    <React.Fragment>
                        <App key="app" state={state} {...rest}/>
                        {typeof DevWidget === 'function' && <DevWidget key="DevWidget" state={state}/>}
                    </React.Fragment>
                )}
            </Consumer>
        </FormValidator>
    );
};

export default AppStateHolder;